import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import './te-text';
import { toKebabCase } from './common/utils';

/** Badge Component */
@customElement('te-badge')
export class TeBadge extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .badge-container {
        border-radius: 16px;
        height: 32px;
        border: 0;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .absolute {
        position: absolute;
      }

      .top-right {
        right: 0;
        top: 0;
        border-radius: 0px 4px;
      }

      .top-left {
        left: 0;
        top: 0;
        border-radius: 4px 0px;
      }

      .bottom-right {
        right: 0;
        bottom: 0;
        border-radius: 4px 0px;
      }

      .bottom-left {
        left: 0;
        bottom: 0;
        border-radius: 0px 4px;
      }
    `,
  ];

  /** Background color of badge */
  @property({ type: String }) backgroundColor = theme.colors.primary.v0.toString();
  /** Text color of badge */
  @property({ type: String }) textColor = theme.colors.shade0.toString();
  /** Primary text value */
  @property({ type: String }) text = '';
  /** Relative placement of badge inside parent  */
  @property({ type: String }) placement?: 'topRight' | 'topLeft' | 'bottomLeft' | 'bottomRight';

  backgroundStyle() {
    return { backgroundColor: this.backgroundColor };
  }

  render() {
    const classes = ['badge-container'];
    if (this.placement) {
      classes.push('absolute');
      classes.push(toKebabCase(this.placement));
    }
    return html`
      <span class=${classes.join(' ')} style=${styleMap(this.backgroundStyle())}>
        <te-text color="${this.textColor}" size="12" weight="500">
          ${this.text}
        </te-text>
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-badge': TeBadge;
  }
}
